import * as React from "react";

const ChevronRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10">
            <path d="M1.006 10.016a1 1 0 01-.71-1.71l3.31-3.29-3.18-3.31a1 1 0 111.42-1.41l3.86 4a1 1 0 010 1.4l-4 4a1 1 0 01-.7.32z" />
        </svg>
    );
};

export const chevronRightStringLight =
    "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDEwIj48cGF0aCBkPSJNMS4wMDYgMTAuMDE2YTEgMSAwIDAxLS43MS0xLjcxbDMuMzEtMy4yOS0zLjE4LTMuMzFhMSAxIDAgMTExLjQyLTEuNDFsMy44NiA0YTEgMSAwIDAxMCAxLjRsLTQgNGExIDEgMCAwMS0uNy4zMnoiIGZpbGw9IiM5RTlGQTMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";

export default React.memo(ChevronRight);
